// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"358":"userinfo","594":"about"}[chunkId] + "." + {"358":"c02a5488","594":"c40e6788"}[chunkId] + ".js";
};